/* eslint-disable @typescript-eslint/no-unused-vars */
export const Disclaimer = (
  prop: { showCalorieDisclaimer: boolean } = { showCalorieDisclaimer: true }
) => null;
